/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_CaptureInputs */

const en_mobile_scan_capture = /** @type {(inputs: Mobile_Scan_CaptureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take photo`)
};

const es_mobile_scan_capture = /** @type {(inputs: Mobile_Scan_CaptureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomar foto`)
};

/**
* | output |
* | --- |
* | "Take photo" |
*
* @param {Mobile_Scan_CaptureInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_capture = /** @type {((inputs?: Mobile_Scan_CaptureInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_CaptureInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_capture(inputs)
	return en_mobile_scan_capture(inputs)
});